import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import GlobalButton from "../../../components/CustomButton";
import appcolors from "../../../constants/Colors";
import { createBusinessPro } from "../../../services/Auth";
import StepFive from "./StepFive";
import StepFour from "./StepFour";
import StepOne from "./StepOne";
import StepThree from "./StepThree";
import StepTwo from "./StepTwo";
import { NavigationSharp } from "@mui/icons-material";
import SnackbarAlert from "../../../components/SnackBar";
import Loader from "../../../components/Loader";
import { setUserPro } from "../../../lib/slices/businessPro";

const stepsList = [
  {
    id: 1,
    name: "Step 1",
    value: "1",
    isActive: true,
    stepColor: "rgb(116 157 50)",
  },
  {
    id: 2,
    name: "Step 2",
    value: "2",
    isActive: false,
    stepColor: appcolors.primary,
  },
  {
    id: 3,
    name: "Step 3",
    value: "3",
    isActive: false,
    stepColor: "rgb(31 168 136)",
  },
  {
    id: 3,
    name: "Step 3",
    value: "3",
    isActive: false,
    stepColor: "rgb(31 168 136)",
  },
  {
    id: 4,
    name: "Step 4",
    value: "3",
    isActive: false,
    stepColor: "rgb(31 168 136)",
  },
  {
    id: 5,
    name: "Step 5",
    value: "3",
    isActive: false,
    stepColor: "rgb(31 168 136)",
  },
];

const SignupSteps = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [currentStep, setCurrentStep] = useState(1);
  const [businessName, setBusinessName] = useState("");
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const [locationDetails, setLocationDetails] = useState({
    address: "",
    lat: null,
    lng: null,
    placeId: "",
  });
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const handleCreateBusinessPro = async () => {
    if (!businessName?.trim()) {
      handleSnackbarVal(true, "error", "Please enter business name");
      return;
    }

    if (selectedServices.length === 0) {
      handleSnackbarVal(true, "error", "Please select services");
      return;
    }

    if (!selectedTeam) {
      handleSnackbarVal(true, "error", "Please select team size");
      return;
    }

    if (!selectedOption?.trim()) {
      handleSnackbarVal(true, "error", "Please tell us how you heard about us");
      return;
    }

    try {
      const params = {
        businessId: user?._id,
        businessName: businessName,
        services: selectedServices,
        teamSize: selectedTeam?.title,
        location: locationDetails?.address
          ? {
              address: locationDetails?.address,
              type: "Point",
              coordinates: [locationDetails.lng, locationDetails.lat],
            }
          : null,
        whereHeared: selectedOption,
      };
      console.log(params,'paramsparamsparams');
      
      // return;
      setIsLoading(true);
      const responce = await createBusinessPro(params);
      setIsLoading(false);

      const data = responce?.data?.data;

      if (responce?.status === 200 || responce?.status === 201) {
        localStorage.setItem("user-Pro", JSON.stringify(data));
        dispatch(setUserPro(data));
        setTimeout(() => {
          navigate(-1, { replace: true });
        }, 500);
      } else {
        handleSnackbarVal(
          true,
          "error",
          responce?.data?.message || "Something went wrong"
        );
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error creating business profile:", error);
      handleSnackbarVal(
        true,
        "error",
        "Something went wrong. Please try again."
      );
    }
  };

  return (
    <Box
      sx={{
        paddingTop: "20px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          minWidth: "800px",
          overflowX: "auto",
          margin: "0 20px",
          justifyContent: "space-between",
          gap: "10px",
        }}
      >
        {stepsList?.map((stepppp, index) => {
          return (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "2px",
                width: "100%",
                borderRadius: "2px",
                background:
                  stepppp.id <= currentStep ? "#EA580C" : "rgb(178 181 178)",
                border: `2.5px solid ${
                  stepppp.id <= currentStep ? "#EA580C" : "rgb(196 196 196)"
                }`,
              }}
            ></Box>
          );
        })}
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          margin: "8px 10px 15px",
          justifyContent: currentStep !== 1 ? "space-between" : "flex-end",
        }}
      >
        {currentStep !== 1 && (
          <Box
            sx={{
              border: "2px solid black",
              borderRadius: "10px",
              padding: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={() => {
              if (currentStep == 1) {
                navigate("/sign-up");
              } else setCurrentStep(currentStep - 1);
            }}
          >
            <ArrowBackIcon />
          </Box>
        )}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{ marginRight: "10px" }}>
            <GlobalButton
              variant={"contained"}
              btnText={currentStep === 5 ? "Done" : "Continue"}
              handleClickBtn={() => {
                if (currentStep === 5) {
                  handleCreateBusinessPro();
                } else {
                  setCurrentStep((prevStep) => prevStep + 1);
                }
              }}
            />
          </Box>
        </Box>
      </Box>
      {currentStep == 1 && (
        <StepOne
          businessName={businessName}
          setBusinessName={setBusinessName}
        />
      )}
      {currentStep == 2 && (
        <StepTwo
          selectedServices={selectedServices}
          setSelectedServices={setSelectedServices}
        />
      )}
      {currentStep == 3 && (
        <StepThree selectItem={selectedTeam} setSelectItem={setSelectedTeam} />
      )}
      {currentStep == 4 && (
        <StepFour
          locationDetails={locationDetails}
          setLocationDetails={setLocationDetails}
        />
      )}
      {currentStep == 5 && (
        <StepFive
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
        />
      )}
      <Loader isLoading={isLoading} />
      <SnackbarAlert
        snackbarProps={snackbarProps}
        handleCloseSnackbar={handleCloseSnackbar}
      />
    </Box>
  );
};

export default SignupSteps;
